import axiosInstance from '../utils/axiosInstance';

export type ClientEmailData = {
  email: string;
};

export default async function getClientEmail() {
  return (await axiosInstance.get<ClientEmailData>('/client/email')).data;
}
